module.exports = __webpack_public_path__ + "static/media/flag-checkered.b4fd2ca5.svg";